import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, user, isInitializing } = useAuthStore();
  const location = useLocation();

  // Anmeldung wird noch ermittelt (Vario-Handshake, INITIAL_SESSION): warten
  // statt umleiten, sonst verliert eine gueltige Session ihr Ziel.
  if (isInitializing) {
    return null;
  }

  if (!isAuthenticated || !user) {
    // Bereits auf der Login-Seite: nicht erneut umleiten (sonst Redirect-Loop,
    // da die Guard via useLocation bei jeder Location-Aenderung neu rendert und
    // ein wechselndes state.from jede Navigation als neu behandelt wird)
    if (location.pathname === '/login') {
      return null;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
